import React, { useEffect, useState, useCallback, useRef } from "react";
import PropTypes from "prop-types";
import pdfjs from "pdfjs-dist";
import PdfViewer from "./PdfViewer";
import Loader from "../Loading/Loader";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const PdfUrlViewer = props => {
  const [loading,setLoading]=useState(true)
  const { url, ...others } = props;


  const pdfRef = useRef();

  const [itemCount, setItemCount] = useState(0);

  useEffect(() => {
    var loadingTask = pdfjs.getDocument(url);
    loadingTask.promise.then(
      pdf => {
        pdfRef.current = pdf;

        setItemCount(pdf._pdfInfo.numPages);

        // Fetch the first page
        var pageNumber = 1;
        pdf.getPage(pageNumber).then(function(page) {
          console.log("Page loaded");
          setLoading(false)
        });
      },
      reason => {
        setLoading(false)
        // PDF loading error
        toast.error('File not found on bucket', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
      });
        console.error(reason);
      }
    );
  }, [url]);

  const handleGetPdfPage = useCallback(index => {
    return pdfRef.current.getPage(index + 1);
  }, []);

  return (<>
    <ToastContainer/>
    <PdfViewer
      {...others}
      itemCount={itemCount}
      getPdfPage={handleGetPdfPage}
    />
    {loading?(
        <Loader />
    ):null}
  </>
  
  );
};

PdfUrlViewer.propTypes = {
  url: PropTypes.string.isRequired
};

export default PdfUrlViewer;
